// TwoFactorSettings.js (optional tab)
import { useState } from "react";
import { toggle2FA, verify2FA } from "../../service/Mainservice";
import "./TwoFactorSettings.css";

// MUI Icons
import SecurityIcon from "@mui/icons-material/Security";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const TwoFactorSettings = ({ currentAdminId }) => {
  const [enabled, setEnabled] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("initial"); // initial | qr | verify | done

  const handleEnable = async () => {
    setLoading(true);
    try {
      const res = await toggle2FA({ enable: true });
      setQrData(res.data);
      setStep("qr");
      setShowQR(true);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to enable 2FA");
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    if (!verificationCode) return alert("Please enter the code");
    setLoading(true);
    try {
      await verify2FA({ code: verificationCode });
      setEnabled(true);
      setStep("done");
      alert("2FA enabled successfully");
    } catch (err) {
      alert(err.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDisable = async () => {
    if (!window.confirm("Disable Two-Factor Authentication?")) return;
    setLoading(true);
    try {
      await toggle2FA({ enable: false });
      setEnabled(false);
      setStep("initial");
      alert("2FA disabled");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to disable 2FA");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="twofactor-settings">
      <h3>Two-Factor Authentication</h3>
      <p>Enhance your account security with two-factor authentication.</p>

      {step === "initial" && (
        <button
          className="btn-primary"
          onClick={handleEnable}
          disabled={loading}
        >
          <SecurityIcon /> Enable 2FA
        </button>
      )}

      {step === "qr" && qrData && (
        <div className="qr-section">
          <p>
            Scan the QR code with your authenticator app (Google Authenticator,
            Authy, etc.)
          </p>
          <img src={qrData.qrCodeUrl} alt="QR Code" />
          <p>
            Or enter this secret manually: <strong>{qrData.secret}</strong>
          </p>
          <div className="form-group">
            <label>Verification Code</label>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="Enter 6-digit code"
            />
          </div>
          <button
            className="btn-primary"
            onClick={handleVerify}
            disabled={loading}
          >
            {loading ? "Verifying..." : "Verify & Enable"}
          </button>
        </div>
      )}

      {step === "done" && (
        <div>
          <p>
            <CheckCircleIcon style={{ color: "green" }} /> 2FA is now enabled.
          </p>
          <button
            className="btn-danger"
            onClick={handleDisable}
            disabled={loading}
          >
            Disable 2FA
          </button>
        </div>
      )}
    </div>
  );
};

export default TwoFactorSettings;
